<template>
  <div class="physical-activity-page chart-content">
    <div>
      <div ref="print">
        <div class="page-card-wrapper">
          <div class="page-card-title">
            <div
              class="left-side-text"
              v-if="$store.state.patient.selectedPatient"
            >
              {{ $store.state.patient.selectedPatient.alias }}
              <span v-if="$store.state.patient.selectedPatient.podMac"
                >({{
                  $store.state.patient.selectedPatient.podMac.substr(-4)
                }})</span
              >
            </div>
            <span class="page-card-title-text">{{
              $t('text.physical_activity_chart')
            }}</span>
            <DateRangePicker />
          </div>
          <div class="page-card-content">
            <PrintSection :chartData="chartData" :loading="loading" />
            <div class="time-location-text">
              {{ $t('text.all_times_are_in') }} {{ location || '--' }}
            </div>
            <div class="text-center legend">
              <div class="inline-block mr-20">
                <span class="status1 legend-item"></span>
                <span>{{ $t('text.low') }}</span>
              </div>
              <div class="inline-block mr-20">
                <span class="status2 legend-item"></span>
                <span>{{ $t('text.medium') }}</span>
              </div>
              <div class="inline-block mr-20">
                <span class="status3 legend-item"></span>
                <span>{{ $t('text.high') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="action-btns mt-20">
        <div
          class="action-btn"
          @click="share()"
          v-if="p('Patients.Charts.PhysicalActivity.Share')"
        >
          <svg-icon
            iconClass="share"
            class="w-15 mr-10"
            className="white-font"
          ></svg-icon>
          <span>{{ $t('text.share') }}</span>
        </div>
        <div
          class="action-btn"
          @click="print()"
          v-if="p('Patients.Charts.PhysicalActivity.Print')"
        >
          <svg-icon
            iconClass="report"
            class="w-15 mr-10"
            className="white-font"
          ></svg-icon>
          <span>{{ $t('text.print') }}</span>
        </div>
      </div>
    </div>
    <ShareDialog ref="shareDialog" />
  </div>
</template>

<script>
import moment from 'moment'
import ApiService from '@/services/ApiService.js'
import ShareDialog from '@/components/patients/charts/ShareDialog'
import { images, hours } from '@/const.js'
import DateRangePicker from '@/components/patients/charts/DateRangePicker'
import PrintSection from '@/components/patients/charts/physicalActivityChart/PrintSection'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import $ from 'jquery'
import swal from 'sweetalert'
export default {
  data() {
    return {
      images,
      moment,
      userLang: navigator.language || navigator.userLanguage,
      hours: hours,
      chartData: [],
      loading: false,
      location: null
    }
  },
  components: {
    ShareDialog,
    DateRangePicker,
    PrintSection
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId': function() {
      this.getData()
    },
    '$store.state.patient.selectedDateRange': function() {
      this.getData()
    }
  },
  mounted: function() {
    this.getData()
  },
  computed: {
    subject() {
      return this.$t('text.physical_activity_chart')
    }
  },
  methods: {
    getData() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.loading = true
      ApiService.GetPatientActivity(
        this.$store.state.patient.selectedPatient.patientId,
        moment(this.$store.state.patient.selectedDateRange[0]).format(
          'YYYY-MM-DD'
        ),
        moment(this.$store.state.patient.selectedDateRange[1]).format(
          'YYYY-MM-DD'
        )
      )
        .then(response => {
          this.loading = false
          if (
            typeof response.data === 'string' &&
            response.data.includes('- demo')
          ) {
            swal({
              icon: 'error',
              title: this.$t('text.failed'),
              text: response.data.replace('- demo', '')
            })
            return false
          }
          this.chartData = response.data.data.activityData
          this.getNightTime(
            response.data.data.nightTimeStart,
            response.data.data.nightTimeEnd
          )
          this.location = response.data.data.Location
        })
        .catch(() => {
          this.loading = false
          this.chartData = []
          swal({
            icon: 'error',
            title: this.$t('text.failed'),
            text: this.$t('text.failed_to_get_chart_data')
          })
        })
    },
    // Dynamically determine the nighttime time range
    getNightTime(nightTimeStart, nightTimeEnd) {
      nightTimeStart =
        moment().format('YYYY-MM-DD') + ' ' + nightTimeStart.split('.')[0]
      nightTimeEnd =
        moment().format('YYYY-MM-DD') + ' ' + nightTimeEnd.split('.')[0]
      this.hours.forEach(hour => {
        const hourValue = moment().format('YYYY-MM-DD') + ' ' + hour.value
        // Consider whether the night time is short or not
        if (moment(nightTimeStart).isAfter(nightTimeEnd)) {
          hour.active =
            moment(hourValue).isSameOrAfter(nightTimeStart) ||
            moment(hourValue).isBefore(nightTimeEnd)
        } else {
          hour.active =
            moment(hourValue).isSameOrAfter(nightTimeStart) &&
            moment(hourValue).isBefore(nightTimeEnd)
        }
      })
    },
    share() {
      this.$refs.shareDialog.openDialog('physical_activity_chart')
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false,
        onclone: doc => {
          $(doc)
            .find('body')
            .css('width', '2200px')
          $(doc)
            .find('.new-design .sidebar-type-page-content')
            .css('width', '100%')
          $(doc)
            .find('.new-design .page-card-wrapper')
            .css('max-width', 'unset')
          $(doc)
            .find('.new-design .page-card-wrapper .page-card-content')
            .css('height', 'auto')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .page-card-title-text'
            )
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .left-side-text'
            )
            .css('display', 'inline-block')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .date-wrapper'
            )
            .css('position', 'absolute')
            .css('top', '6px')
            .css('right', '10px')
          $(doc)
            .find('.el-range-editor .el-range-input')
            .css('line-height', '24px')
        }
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image'
        })
      })
    }
  }
}
</script>
